export class ModuleConfiguration {
  static moduleName = 'vocabulary';
}



// WEBPACK FOOTER //
// ./src/app/vocabulary/vocabulary.module.config.ts